import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'h-fit w-full max-w-46.5 justify-between px-0 normal-case md:max-w-56.25',
    button: 'flex-center mx-auto normal-case',
    label: 'grow-1',
    buttonChildren: 'flex-center w-full gap-2',
    icon: 'rotate-90',
    input: 'h-8 py-0',
    sortButton:
      'heading-s-bold md:heading-m-bold flex cursor-pointer items-center gap-1.5 md:gap-2',
    sortButtonIcon: 'text-main mt-0.5 size-6 rotate-90 transition-transform'
  },
  variants: {
    open: {
      true: {
        sortButtonIcon: 'scale-x-[-1]'
      }
    }
  }
});
